import React from 'react';
import { Link } from 'react-router-dom';

const DButton = ({ text, to }) => {
  return (
    <Link className='d-button fcc' to={to}>
      {text}
      <span className="underline"></span>
    </Link>
  )
}

export default DButton